import CryptoJS from 'crypto-js';

// Get the encryption key (must be 32 characters for AES-256)
const ENCRYPTION_KEY = process.env.REACT_APP_ENCRYPTION_KEY;

// Ensure the key length is valid
const getEncryptionKey = () => {
    if (!ENCRYPTION_KEY || ENCRYPTION_KEY.length !== 32) {
        throw new Error('REACT_APP_ENCRYPTION_KEY must be exactly 32 characters long.');
    }
    return CryptoJS.enc.Utf8.parse(ENCRYPTION_KEY);
};

// Encrypt data
export const encryptData = (data) => {
    const stringifiedData = JSON.stringify(data); // Convert data to string
    const key = getEncryptionKey();

    // Generate a random IV (16 bytes)
    const iv = CryptoJS.lib.WordArray.random(16);

    // Encrypt data with AES-256-CBC
    const encrypted = CryptoJS.AES.encrypt(stringifiedData, key, {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
    });

    // Combine IV and encrypted data into a single string
    return `${iv.toString(CryptoJS.enc.Hex)}:${encrypted.ciphertext.toString(CryptoJS.enc.Hex)}`;
};

// Decrypt data
export const decryptData = (encryptedData) => {
    const key = getEncryptionKey();
    // log the encrypted data
    console.log("encryptedData receieved", encryptedData);

    // Validate input
    if (typeof encryptedData !== "string" || !encryptedData.includes(':')) {
        throw new Error("Invalid encrypted data format");
    }

    // Split the IV and ciphertext
    const [ivHex, ciphertextHex] = encryptedData.split(':');
    const iv = CryptoJS.enc.Hex.parse(ivHex);
    const ciphertext = CryptoJS.enc.Hex.parse(ciphertextHex);

    // Decrypt data with AES-256-CBC
    const decrypted = CryptoJS.AES.decrypt(
        { ciphertext: ciphertext },
        key,
        {
            iv: iv,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7,
        }
    );

    // Parse the decrypted plaintext
    try {
        console.log("Decrypted data", CryptoJS.enc.Utf8.stringify(decrypted));
        return JSON.parse(CryptoJS.enc.Utf8.stringify(decrypted)); // Convert back to original data
    } catch (err) {
        throw new Error("Failed to parse decrypted data");
    }
};


export default { encryptData, decryptData };
